import { IMAGE_POSITION_OPTIONS } from "../../lib/image-position";

export const BeforeAfterFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description:
        "Section heading that frames the transformations as proof (e.g. 'Before and After: Real Jobs in Austin')",
      seo: true,
      key: "beforeAfter.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Short intro that tells visitors what these comparisons show",
      seo: true,
      key: "beforeAfter.subheading",
    },
  },
  beforeLabel: {
    type: "text",
    label: "Before Label",
    metadata: {
      source: "manual",
      description: "Chip shown on the left side of the photo. Clear it to hide the chip.",
    },
  },
  afterLabel: {
    type: "text",
    label: "After Label",
    metadata: {
      source: "manual",
      description: "Chip shown on the right side of the photo. Clear it to hide the chip.",
    },
  },
  aspectRatio: {
    type: "select",
    label: "Photo Shape",
    options: [
      { label: "Standard (4:3)", value: "4:3" },
      { label: "Wide (16:9)", value: "16:9" },
      { label: "Square", value: "1:1" },
      { label: "Tall (3:4)", value: "3:4" },
    ],
    metadata: {
      source: "manual",
      description: "Both photos crop to this shape so the comparison lines up",
    },
  },
  startPosition: {
    type: "select",
    label: "Start Showing",
    options: [
      { label: "Half and half", value: "half" },
      { label: "Mostly the after", value: "mostly-after" },
      { label: "Mostly the before", value: "mostly-before" },
    ],
    metadata: {
      source: "manual",
      description: "Where the divider sits before the visitor moves it",
    },
  },
  pairs: {
    type: "array",
    label: "Comparisons",
    metadata: {
      source: "manual",
      description: "Before and after photo pairs from real jobs",
      seo: true,
      key: "beforeAfter.pairs",
    },
    getItemSummary: (item: { caption?: string; alt?: string }, index?: number) =>
      item?.caption || item?.alt || `Comparison ${(index ?? 0) + 1}`,
    arrayFields: {
      beforeImageUrl: {
        type: "custom",
        label: "Before Photo",
        metadata: {
          description: "The job before the work",
        },
      },
      afterImageUrl: {
        type: "custom",
        label: "After Photo",
        metadata: {
          description: "The same job after the work",
        },
      },
      caption: {
        type: "text",
        label: "Caption",
        metadata: {
          description: "One line about the job, shown under the comparison",
          seo: true,
        },
      },
      alt: {
        type: "text",
        label: "Alt Text",
        metadata: {
          description: "Describe the work shown for accessibility and SEO",
          seo: true,
        },
      },
      beforeFocus: {
        type: "select",
        label: "Before Photo Focus",
        options: [...IMAGE_POSITION_OPTIONS],
        metadata: {
          source: "manual",
          description: "Which part of the before photo stays visible when it crops",
        },
      },
      afterFocus: {
        type: "select",
        label: "After Photo Focus",
        options: [...IMAGE_POSITION_OPTIONS],
        metadata: {
          source: "manual",
          description: "Which part of the after photo stays visible when it crops",
        },
      },
    },
    defaultItemProps: {
      beforeImageUrl: "",
      afterImageUrl: "",
      caption: "",
      alt: "",
      beforeFocus: "center",
      afterFocus: "center",
    },
  },
  ctaText: {
    type: "text",
    label: "Button Text",
    metadata: {
      source: "manual",
      description: "Optional button under the section (e.g. 'Get a Free Quote')",
    },
  },
  ctaHref: {
    type: "text",
    label: "Button Link",
    metadata: {
      source: "manual",
      description: "Where the button goes",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
